import React from 'react';

interface FocusAreaProps {
  enabled: boolean;
  centerPercent: number;
  heightPercent: number;
  intensity: number;
}

export const FocusArea: React.FC<FocusAreaProps> = ({
  enabled,
  centerPercent,
  heightPercent,
  intensity,
}) => {
  if (!enabled || intensity <= 0) return null;

  const topPercent = Math.max(0, centerPercent - heightPercent / 2);

  return (
    <div
      className="absolute left-0 right-0 pointer-events-none transition-all duration-150 z-10"
      style={{
        top: `${topPercent}%`,
        height: `${heightPercent}%`,
        backgroundColor: `rgba(255, 255, 255, ${intensity})`,
      }}
      aria-hidden="true"
    />
  );
};
